<div style="display: flex; flex-direction: column; height: 100%">
  <app-modal-header-common [title]="'People Insights'" [dialogRef]="dialogRef">
  </app-modal-header-common>
  <div class="px-3 py-2">
    <ul>
      <li
        *ngFor="
          let breadcrumb of breadCrumbData;
          first as isFirst;
          last as isLast
        "
      >
        <span *ngIf="!isLast" class="color-history-inactive">{{
          breadcrumb
        }}</span>
        <span *ngIf="isLast" class="color-active">{{ breadcrumb }}</span>
      </li>
    </ul>
  </div>
  <app-loading *ngIf="!dataLoaded"></app-loading>
  <div class="single-center-pane">
    <div style="flex-grow: 1">
      <div>
        <div style="display: flex"></div>
      </div>

      <ng-container *ngIf="currentReportUrl!='error' && dataLoaded;">
        <div class="zoho-dashboard-responsive">
          <div class="middle-pane">
            <div class="dashboard-container">
              <div class="tab-container">
                <div class="tabs">
                  <button
                    *ngFor="let tab of dashboardTabs"
                    [class.active]="tab.id === activeTabName"
                    (click)="switchTab(tab.id)"
                    style="height: 50px"
                  >
                    {{ tab.name }}
                  </button>
                </div>
              </div>

              <div #reportView class="report-root"></div>
            </div>
          </div>
        </div>
      </ng-container>

      <ng-container *ngIf="dataLoaded && currentReportUrl=='error'">
        <div class="no-dashboard">Unable to load dashboard</div>
      </ng-container>
    </div>
  </div>
  <div class="modal-footer d-flex justify-content-end gap-2 p-2">
    <button
      (click)="closeModal()"
      mat-button
      mat-dialog-close
      color="primary"
      class="mx-1"
    >
      Close
    </button>
  </div>
</div>
